<template>
    <v-container style="padding: 16px;">
        <v-row class="reports-ticket-container">
            <v-col
                class="d-flex"
                cols="6"
                sm="3"
            >
                <v-select
                    v-model="selectedMemberCode"
                    label="Member Code"
                    :items="member_code"
                    item-text="name"
                    dense
                    outlined
                    @change="changeMemberCode"
                />
            </v-col>
        </v-row>
        <v-row class="w-100p">
            <v-card
                v-for="report in selectedMemberCodeItems.values"
                :key="report.rowid"
                class="reports-container mb-4"
                width="100%"
                height="100%"
                outlined
            >
                <v-row class="mx-2 d-flex flex-column">
                    <div class="custom-header">
                        <span>{{ report.report_name }} - {{ report.created }} </span>
                    </div>
                    <div
                        class="cutom-body"
                        style="white-space: pre-line;"
                    >
                        {{ report.report_text }}
                    </div>
                </v-row>
            </v-card>
        </v-row>
    </v-container>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'ReportsComponent',
    data: () => ({
        member_code: [],
        selectedMemberCode: 'All',
        selectedMemberCodeItems: {name: '', values: []},
    }),
    computed: {
        getTicketDetails() {
            return this.$store.getters.ticketDetails;
        }
    },
    created() {
        this.getReportHistory();
    },
    methods: {
        getReportHistory() {
            if(this.getTicketDetails) {
                if(this.getTicketDetails.Ticket_Reports) {
                    this.getTicketDetails.Ticket_Reports = this.getTicketDetails?.Ticket_Reports.map((item) => {
                        item.member_code = item.report_name.split(':')[1];
                        return item;
                    });
                    let groupedMemberCode = _.groupBy(this.getTicketDetails?.Ticket_Reports, 'member_code');
                    this.member_code = Object.keys(groupedMemberCode).map((key) => {
                        return { name: key, values: groupedMemberCode[key] };
                    });
                    this.member_code.unshift({ name: 'All', values: this.getTicketDetails?.Ticket_Reports });
                    this.changeMemberCode('All');
                }
            }
        },
        changeMemberCode(event) {
            this.selectedMemberCodeItems = this.member_code.find(item => item.name === event);
        }
    }
};
</script>

<style>
    .reports-ticket-container {
        display: flex;
        justify-content: space-between !important;
        color: var(--ll-text-primary);
        height: 70px;
    }
    .reports-container {
        border: none !important;
        padding: 12px 12px 8px !important;
        height: 145px;
    }
    .custom-header { 
        padding: 8px 0px;
        border-bottom: 1px solid var(--ll-border);
    }
    .cutom-body {
        margin: 10px 0px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.0025em;
        color: var(--ll-text-primary);
    }
</style>
